// extracted by mini-css-extract-plugin
export default {"tt":"Tooltip_tt__6owGs","ttWrapper":"Tooltip_ttWrapper__txrHP","show":"Tooltip_show__RRI0M"};